import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { AppKitProvider, getAppKit } from "./librairies/appKit";
import ConnectButton from "./components/ConnectButton";
import GameBoard from "./components/GameBoard";
import LeaderboardPopup from "./components/LeaderboardPopup";
import celoLogo from "./assets/celo-logo.jpg";
import "./index.css";
import Web3 from "web3";
import Celo_2048_ABI from "./Celo2048_ABI.json";
import { celo, celoSepolia } from "@reown/appkit/networks";
import { sdk } from "@farcaster/miniapp-sdk";

const NETWORK_CONTRACTS = {
  "42220": process.env.REACT_APP_CONTRACT_ADDRESS_CELO_MAINNET,
  "0xa4ec": process.env.REACT_APP_CONTRACT_ADDRESS_CELO_MAINNET,
  "1114572": process.env.REACT_APP_CONTRACT_ADDRESS_CELO_SEPOLIA,
  "0xaa044c": process.env.REACT_APP_CONTRACT_ADDRESS_CELO_SEPOLIA,
};

const RPC_FALLBACK = {
  [celo.chainId]: "https://forno.celo.org",
  [celoSepolia.chainId]: "https://alfajores-forno.celo-testnet.org",
};

function Root() {
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [leaderboardData, setLeaderboardData] = useState({ bestScores: [], totalScores: [] });

  async function fetchLeaderboard() {
    try {
      let chainIdHex = null;
      try {
        const appKit = getAppKit();
        const activeNetwork = appKit?.getNetwork?.();
        if (activeNetwork?.chainId) chainIdHex = activeNetwork.chainId;
      } catch {}
      if (!chainIdHex && window.ethereum) {
        chainIdHex = await window.ethereum.request({ method: "eth_chainId" });
      }
      if (!chainIdHex) return;

      const contractAddress = NETWORK_CONTRACTS[chainIdHex] || NETWORK_CONTRACTS[Number(chainIdHex)];
      if (!contractAddress) return;

      const web3 = window.ethereum ? new Web3(window.ethereum) : new Web3(RPC_FALLBACK[chainIdHex] || RPC_FALLBACK[Number(chainIdHex)] || RPC_FALLBACK[celoSepolia.chainId]);
      const contract = new web3.eth.Contract(Celo_2048_ABI, contractAddress);

      const bestRaw = await contract.methods.getBestScores().call();
      const totalRaw = await contract.methods.getTotalScores().call();

      const bestScores = (bestRaw[0] || []).map((addr, i) => ({
        player: addr,
        score: Number(bestRaw[1][i] || 0),
        time: Number(bestRaw[2][i] || 0),
      })).filter(x => x.player);

      const totalScores = (totalRaw[0] || []).map((addr, i) => ({
        player: addr,
        scoreTotal: Number(totalRaw[1][i] || 0),
        gamesPlayed: Number(totalRaw[2][i] || 0),
      })).filter(x => x.player);

      bestScores.sort((a, b) => b.score - a.score);
      totalScores.sort((a, b) => b.scoreTotal - a.scoreTotal);

      setLeaderboardData({ bestScores, totalScores });
      sdk.actions.ready();
    } catch (err) {
      sdk.actions.ready();
    }
  }

  window.refreshLeaderboard = fetchLeaderboard;

  useEffect(() => {
    if (!window.ethereum) return;
    const handleChainChanged = () => fetchLeaderboard();
    window.ethereum.on("chainChanged", handleChainChanged);
    return () => window.ethereum.removeListener("chainChanged", handleChainChanged);
  }, []);

  useEffect(() => { fetchLeaderboard(); }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minHeight: "100vh", padding: "20px", backgroundColor: "#fff8e1", fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
        <img src={celoLogo} alt="Celo Logo" style={{ width: "50px", height: "50px" }} />
        <h1 style={{ fontSize: "1.8rem", fontWeight: "bold" }}>Celo 2048</h1>
      </div>
      <ConnectButton />
      <button onClick={async () => { await fetchLeaderboard(); setShowLeaderboard(true); }} style={{ padding: "8px 16px", backgroundColor: "#f5b700", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", margin: "20px 0" }}>
        Leaderboards
      </button>
      <GameBoard />
      {showLeaderboard && <LeaderboardPopup leaderboardData={leaderboardData} onClose={() => setShowLeaderboard(false)} />}
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppKitProvider>
      <Root />
    </AppKitProvider>
  </React.StrictMode>
);
